"use client";

import Script from "next/script";

import { env } from "../../../utils/libs/env";

declare global {
  interface Window {
    pendo?: {
      track: (eventName: string, metadata?: Record<string, unknown>) => void;
      initialize: (config: {
        visitor: { id: string };
      }) => void;
      _q?: unknown[];
    };
  }
}

export function PendoScript() {
  const pendoAppId = env.NEXT_PUBLIC_PENDO_APP_ID;

  if (!pendoAppId) {
    return null;
  }

  return (
    <>
      <Script
        id="pendo-init"
        strategy="afterInteractive"
        // biome-ignore lint/security/noDangerouslySetInnerHtml: Pendo initialization requires inline script
        dangerouslySetInnerHTML={{
          __html: `
            (function(apiKey){
              (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
              v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
              o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
              y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
              z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');

              pendo.initialize({});
            })('${pendoAppId}');
          `,
        }}
      />
    </>
  );
}
